/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpCategoryUpdateSubCategoryResponse } from './CarpCategoryUpdateSubCategoryResponse';

export type CarpCategoryUpdateSubCategoryResponseApiRespoonse = {
    data?: CarpCategoryUpdateSubCategoryResponse;
    status?: CarpCategoryUpdateSubCategoryResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpCategoryUpdateSubCategoryResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

